interface NavButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  href?: string;
  isScrolled?: boolean;
}

export const NavLink = ({ children, href, onClick }: NavButtonProps) => {
  return (
    <a
      href={href}
      onClick={onClick}
      dir="rtl"
      className={`inline-flex items-center justify-center px-4 bg-white border-[3px] border-black rounded-md font-extrabold text-burgundy text-lg active:translate-y-[2px] active:shadow-[0_4px_0_#000] transition-all select-none`}
    >
      {children}
    </a>
  );
};
